"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftRailHeader = void 0;
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = tslib_1.__importStar(require("react"));
var LeftRailButton_1 = require("../../containers/LeftRailButton/LeftRailButton");
require("./styles.less");
var onBackClick = function () {
    window.history.back();
};
var IS_RETURNABLE_HASH = '#returnable';
exports.LeftRailHeader = mobx_react_1.observer(function (props) {
    var card = props.videoPageStore.activeCard;
    if (!card) {
        return null;
    }
    var isReturnable = window.location.hash === IS_RETURNABLE_HASH;
    var backToList;
    if (isReturnable && window.history.length === 1) {
        isReturnable = false;
        window.location.hash = '';
    }
    if (!isReturnable || document.referrer === '') {
        backToList = (React.createElement(LeftRailButton_1.LeftRailButton, { url: props.homepageUrl, title: 'Back to list' }));
    }
    else {
        backToList = (React.createElement(LeftRailButton_1.LeftRailButton, { onClick: onBackClick, title: 'Back to list' }));
    }
    return (React.createElement("header", { className: 'm-left-rail-header' },
        React.createElement("a", { className: 'm-left-rail-header__link', href: props.homepageUrl, target: '_self' }, "Green Section Record"),
        React.createElement("span", { className: 'm-left-rail-header__date' }, card.issueDate),
        React.createElement("div", { className: 'm-left-rail-header__column' }, renderIssues(card.issues)),
        React.createElement("div", { className: 'm-left-rail-header__buttons' },
            backToList,
            React.createElement(LeftRailButton_1.LeftRailButton, { url: props.subscribeLink, title: 'Subscribe', colored: true }))));
});
function renderIssues(issues) {
    if (!(issues && issues.length)) {
        return;
    }
    return issues.map(function (value, index) {
        return React.createElement("span", { className: 'm-left-rail-header__tag', key: index }, value);
    });
}
